import axios from 'axios';

const emailActivation = (data) => (
  axios.post(
    `${process.env.REACT_APP_USER_API_ENDPOINT}/auth/email-activation`,
    data,
  ));

export default emailActivation;
